import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-app',
  templateUrl: './our-app.component.html',
  styleUrls: ['./our-app.component.css']
})
export class OurAppComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
